import {
  HIDE_BOOKING_LOADER,
  HIDE_CANCEL_EQUEUE_LOADER,
  HIDE_CONFIRM_LOADER,
  HIDE_DATES_LOADER,
  HIDE_DOCTOR_NAMES_LOADER,
  HIDE_DOCTORS_LOADER,
  HIDE_EQUEUES_LOADER,
  HIDE_LOGIN_FORM_LOADER,
  HIDE_MOSCOW_SCENARIO_LOADER,
  HIDE_REGIONS_LOADER,
  HIDE_SELECTED_EQUEUE_LOADER,
  HIDE_USER_INFO_LOADER,
  SHOW_BOOKING_LOADER,
  SHOW_CANCEL_EQUEUE_LOADER,
  SHOW_CONFIRM_LOADER,
  SHOW_DATES_LOADER,
  SHOW_DOCTOR_NAMES_LOADER,
  SHOW_DOCTORS_LOADER,
  SHOW_EQUEUES_LOADER,
  SHOW_LOGIN_FORM_LOADER,
  SHOW_MOSCOW_SCENARIO_LOADER,
  SHOW_REGIONS_LOADER,
  SHOW_SELECTED_EQUEUE_LOADER,
  SHOW_USER_INFO_LOADER,
} from "./types";

export const showLoginFormLoader = () => {
  return {
    type: SHOW_LOGIN_FORM_LOADER,
  };
};

export const hideLoginFormLoader = () => {
  return {
    type: HIDE_LOGIN_FORM_LOADER,
  };
};

export const showQueuesLoader = () => {
  return {
    type: SHOW_EQUEUES_LOADER,
  };
};

export const hideQueuesLoader = () => {
  return {
    type: HIDE_EQUEUES_LOADER,
  };
};

export const showSelectedEqueueLoader = () => {
  return {
    type: SHOW_SELECTED_EQUEUE_LOADER,
  };
};

export const hideSelectedEqueueLoader = () => {
  return {
    type: HIDE_SELECTED_EQUEUE_LOADER,
  };
};

export const showCancelEqueuesLoader = () => {
  return {
    type: SHOW_CANCEL_EQUEUE_LOADER,
  };
};

export const hideCancelEqueuesLoader = () => {
  return {
    type: HIDE_CANCEL_EQUEUE_LOADER,
  };
};

export const showUserInfoLoader = () => {
  return {
    type: SHOW_USER_INFO_LOADER,
  };
};

export const hideUserInfoLoader = () => {
  return {
    type: HIDE_USER_INFO_LOADER,
  };
};

export const showDoctorsLoader = () => {
  return {
    type: SHOW_DOCTORS_LOADER,
  };
};

export const showDoctorNamesLoader = () => {
  return {
    type: SHOW_DOCTOR_NAMES_LOADER,
  };
};

export const hideDoctorNamesLoader = () => {
  return {
    type: HIDE_DOCTOR_NAMES_LOADER,
  };
};

export const hideDoctorsLoader = () => {
  return {
    type: HIDE_DOCTORS_LOADER,
  };
};

export const showDatesLoader = () => {
  return {
    type: SHOW_DATES_LOADER,
  };
};

export const hideDatesLoader = () => {
  return {
    type: HIDE_DATES_LOADER,
  };
};

export const showConfirmLoader = () => {
  return {
    type: SHOW_CONFIRM_LOADER,
  };
};

export const hideConfirmLoader = () => {
  return {
    type: HIDE_CONFIRM_LOADER,
  };
};

export const showRegionsLoader = () => {
  return {
    type: SHOW_REGIONS_LOADER,
  };
};

export const hideRegionsLoader = () => {
  return {
    type: HIDE_REGIONS_LOADER,
  };
};
export const showBookingLoader = () => {
  return {
    type: SHOW_BOOKING_LOADER,
  };
};

export const hideBookingLoader = () => {
  return {
    type: HIDE_BOOKING_LOADER,
  };
};

export const showMoscowScenarioLoader = () => {
  return {
    type: SHOW_MOSCOW_SCENARIO_LOADER,
  };
};

export const hideMoscowScenarioLoader = () => {
  return {
    type: HIDE_MOSCOW_SCENARIO_LOADER,
  };
};
